export default __webpack_public_path__ + "static/media/howtouse_basic_02_en.544da675.png";